import api from "../common/api";

const uploadImage = (data) => api.post("images", data);

const imagesService = { uploadImage };

export default imagesService;
